import React, { FC } from 'react';
import styled from '@emotion/styled';
import { colorVariables, fontLevelBox, fontWeights } from '../../base/theme';
import { ElementProps } from './types';

const unforwardedProps = {
    fontLevel: true,
    fontWeight: true,
    colorKey: true,
    align: true,
    padding: true
};

const shouldForwardProp = (p: string) => !unforwardedProps[p];

const Element: FC<ElementProps> = ({ element, children, ...rest }) => {
    switch (element) {
        case 'p':
            return <p {...rest}>{children}</p>;
        case 'div':
            return <div {...rest}>{children}</div>;
        default:
            return <span {...rest}>{children}</span>;
    }
};

export const StyledText = styled((props) => <Element {...props} />, { shouldForwardProp })`
  margin: 0;
  ${({ fontLevel }) => fontLevelBox[fontLevel]};
  font-weight: ${({ fontWeight }) => fontWeights[fontWeight]};
  color: ${({ colorKey }) => colorVariables[colorKey]};
  text-align: ${({ align }) => align};
  padding: ${({ padding }) => padding};
`;
